<template>
  <section>
    <div class="flex justify-center items-center">
      <p class="text-fg-muted font-normal text-13px">Asset Deposit</p>
    </div>
    <div
      class="mt-5 border-style rounded-lg flex items-center justify-center py-5"
    >
      <div>
        <p class="text-sm text-fg-muted font-normal mb-2 text-center">
          You will deposit exactly
        </p>
        <p class="text-black text-2xl font-bold text-center">
          {{
            parseMoneyAll(
              assetDepositDetails.amount,
              assetDepositDetails.currency
            )
          }}
        </p>
      </div>
    </div>
    <div class="mt-10 px-14">
      <div class="flex justify-between items-center px-5">
        <div class="flex items-start gap-x-2">
          <currency-icons
            :currency="getCurrencyCountry(assetDepositDetails.currency)"
          />
          <div>
            <p class="text-xs font-normal text-fg-muted">Asset</p>
            <p class="text-black font-medium text-sm">
              {{ assetDepositDetails.currency }}
            </p>
          </div>
        </div>
        <div class="flex items-start gap-x-2">
          <network-icons
            :currency="getNetworkFullName(assetDepositDetails.network)"
          />
          <div>
            <p class="text-xs font-normal text-fg-muted">Network</p>
            <p class="text-black font-medium text-sm">
              {{ assetDepositDetails.network }}
            </p>
          </div>
        </div>
      </div>
      <p class="text-center text-sm text-fg-muted font-bold mt-5">
        Scan address to make deposit
      </p>
      <div>
        <div class="flex justify-center mt-8">
          <qrcode-vue
            :value="assetDepositDetails.address"
            :size="size"
            level="H"
          />
        </div>
      </div>
      <div
        class="bg-bg-muted w-full flex justify-center flex-col items-center mt-5 py-3 rounded-lg"
      >
        <p class="text-xs text-fg-muted font-normal">DEPOSIT ADDRESS</p>
        <div class="flex items-center mt-3">
          <p class="text-xs text-black font-medium mr-0.5">
            {{ maskID(assetDepositDetails.address) }}
          </p>
          <div
            class="cursor-pointer"
            v-clipboard:copy="assetDepositDetails.address"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <copy-icon />
          </div>
        </div>
      </div>
    </div>
    <div
      class="border border-red-1 bg-red-3 p-2 rounded-lg mx-5 flex items-center gap-x-1.5 mt-5"
    >
      <warning-icon-red />
      <p class="text-red-5 text-13px font-normal">
        Only send {{ assetDepositDetails.currency }} ({{
          assetDepositDetails.network
        }}) to this address
      </p>
    </div>
    <div class="mt-8 w-full flex items-center gap-x-4 text-sm font-normal">
      <div
        class="w-1/2 bg-white border border-primary text-primary py-3.5 rounded-md cursor-pointer text-center"
        @click="handleClose"
      >
        Deposit Later
      </div>
      <div
        class="w-1/2 bg-primary text-white py-3.5 rounded-md cursor-pointer text-center"
        @click="initiateAssetDeposit"
      >
        Done
      </div>
    </div>
  </section>
</template>
<script>
import {
  GetCurrencyCountry,
  ParseMoneyAll,
  GetNetworkFullName
} from '@/utils/helpers.js'
import QrcodeVue from 'qrcode.vue'
export default {
  data () {
    return {
      size: 200
    }
  },
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    NetworkIcons: () => import('@/assets/v2/icons/NetworkIcons.vue'),
    CopyIcon: () => import('@/assets/icons/CopyIcon.vue'),
    WarningIconRed: () => import('@/assets/v2/icons/WarningIconRed.vue'),
    QrcodeVue
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    initiateAssetDeposit () {
      this.$emit('next')
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    getNetworkFullName (val) {
      return GetNetworkFullName(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    maskID (val) {
      return val.substring(0, 12) + '...'
    },
    onCopy: function (e) {
      this.$notify.success({
        title: 'Deposit Address Copied'
      })
    },
    onError: function (e) {
      this.$notify.error('Error copying to clipboard!')
    }
  },
  computed: {
    assetDepositDetails () {
      return this.$store.state.transactions.assetDepositDetails
    }
  }
}
</script>
<style scoped>
.border-style {
  border: 1px solid var(--border-main);
}
</style>
